import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';

const CourseLayout = ({ children }) => {
    return <Container>{children}</Container>;
};

CourseLayout.propTypes = {
    children: PropTypes.node.isRequired
};

export default CourseLayout;
